import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

const myCustomTheme = {
  dark: false,
  colors: {
    background: '#FCFCFC',
    surface: '#FFFFFF',
    'side-menu': '#F9F9F8',    
    primary: '#007CB8',
    'primary-dark': '#003250',
    secondary: '#007CB8',  
    error: '#B00020',     
    
    // --- CUSTOM BRAND SHADES ---
    'profile-color': '#1976D2',
    'brand-light': '#68BF9D',   
    'brand-accent': '#77BFA3',  
    'brand-pale': '#B9DCCE',    
    'brand-mint': '#97E2C5', 
    'brand-faint': '#EBFFF7',  

    // --- CUSTOM GREYSCALE (B/W) ---
    'heading': '#141414',      
    'status-active': '#2db923ff',
    'status-inactive': '#CCCCCC',
    'neutral': '#5A5A5A',         
    'description': '#8E938E',  
    'placeholder': '#9BA09E',   
    'divider': '#DADDDC',      
    'stroke': '#E5E5E5',        
  },
  // Variables allow you to override standard text opacity/colors globally if needed
  variables: {
    'border-color': '#DADDDC',
    'theme-on-background': '#141414', 
    'theme-on-surface': '#141414',
  }
}

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    ssr: true,
    theme: {
      defaultTheme: 'myCustomTheme',
      themes: {
        myCustomTheme,
      },
    },
  })
  app.vueApp.use(vuetify)
})